import React, { useState } from 'react'
import { Button } from 'react-bootstrap'





export default function PrimaryButton({ buttonName, onClick, type, loadingMessage, isLoading, style, iconClassName, needIcon, className, disabled }) {


    return (

        <Button
            onClick={onClick}
            variant="primary"
            type={type}
            disabled={isLoading || disabled}
            style={{
                ...style,
                borderRadius: '8px',
            }}
            className={className}
        >
            <div className='row'>

                {needIcon && <div className='col-2'></div>}
                <div className={needIcon ? "col-8" : 'col-12'}>
                    {isLoading ? loadingMessage : buttonName}
                </div>
                {needIcon && <div className='col-2 d-flex justify-content-end align-items-center'>
                    {needIcon && <i className={iconClassName}></i>}
                </div>}
            </div>


        </Button>



    )
}

